export default __webpack_public_path__ + "static/media/i16.cf71031f.svg";